import { Mail, MapPin, Phone, Send } from 'lucide-react';
import { useState } from 'react';
import LoadingState from '../../components/common/LoadingState.jsx';
import PageHero from '../../components/common/PageHero.jsx';
import Seo, { SITE_URL } from '../../components/common/Seo.jsx';
import { useContent } from '../../hooks/useContent.js';

export default function ContactPage() {
  const { content, status } = useContent();
  const [sent, setSent] = useState(false);
  if (status === 'loading') return <LoadingState label="Loading contact page" />;
  const contact = content.contact;

  function submitContact(event) {
    event.preventDefault();
    event.currentTarget.reset();
    setSent(true);
  }

  return (
    <>
      <Seo
        title="Contact Us"
        description="Contact La Bella Trading in Ottawa — questions about raw honey, olive oil, natural soaps, orders, or delivery. 456 McArthur Avenue, Unit 107."
        path="/contact"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          url: `${SITE_URL}/contact`,
          about: {
            '@type': 'OnlineStore',
            name: 'La Bella Trading',
            email: contact.email || undefined,
            telephone: contact.phone ? `+1${String(contact.phone).replace(/[^\d]/g, '')}` : undefined,
            address: {
              '@type': 'PostalAddress',
              streetAddress: '456 McArthur Avenue, Unit 107',
              addressLocality: 'Ottawa',
              addressRegion: 'ON',
              postalCode: 'K1K 4B5',
              addressCountry: 'CA',
            },
          },
        }}
      />
      <PageHero
        eyebrow="Contact"
        title={contact.title}
        text="Questions about an order, product, or delivery? Send us a note — we answer quickly."
        image="assets/uploads/contact-banner.png"
      />
      <section className="container page-section">
        <div className="contact-grid">
          <form className="checkout-form" onSubmit={submitContact}>
            <span className="form-legend">Send a message</span>
            <div className="form-grid-2">
              <label>Name<input name="visitor_name" required /></label>
              <label>Phone<input name="visitor_phone" /></label>
            </div>
            <label>Email<input name="visitor_email" type="email" required /></label>
            <label>Message<textarea name="visitor_message" rows="5" required /></label>
            <button className="button button-honey" type="submit"><Send size={17} /> Send Message</button>
            {sent ? <p className="form-message">Message ready. We will be in touch.</p> : null}
          </form>
          <aside className="info-card">
            <h2>La Bella Trading</h2>
            {contact.address ? (
              <div className="info-row"><MapPin size={18} /><span>{contact.address.trim()}</span></div>
            ) : null}
            {contact.email ? (
              <a className="info-row" href={`mailto:${contact.email}`}><Mail size={18} /><span>{contact.email}</span></a>
            ) : null}
            {contact.phone ? (
              <a className="info-row" href={`tel:${contact.phone}`}><Phone size={18} /><span>{contact.phone}</span></a>
            ) : null}
          </aside>
        </div>
      </section>
    </>
  );
}
